export enum IMessageType {
  Received = 1,
  Send = 2,
}
